import { z } from 'zod';

export const complementaryInfoSchema = z.object({
  hasRQTH: z.boolean(),
  complementaryMentions: z.array(z.string()),
});

export type ComplementaryInfoFormValues = z.infer<typeof complementaryInfoSchema>;
